<template>
    <div class="confirm section">
        <h3>Last step</h3>
        <div style="width: 90%; margin: auto;">
            <ul style="margin-bottom: 15px;">
                <li>
                    You are reserving <b>{{ details.house.name }}</b> for the dates <b>{{ formattedDateRange }}</b>.
                </li>
                <li>
                    A <b>{{ isDeposit ? 'deposit' : 'payment' }}
                    <span v-if="details.paymentDue > 0">of ${{ details.paymentDue.toFixed(2) }}</span></b>
                    is required to confirm your reservation.
                    <br>
                    Your card will not be charged until we confirm your reservation request.
                </li>
                <li v-if="isDeposit">
                    The <b>final payment of ${{ details.finalPayment.toFixed(2) }}</b> will be charged to
                    your card on <b>{{ details.finalPaymentDate.format('MMMM D, YYYY') }}</b>.
                </li>

            </ul>

            <template v-if="!complete">
                <button
                    @click="$emit('submit-request')"
                    :disabled="!maySubmit"
                    class="button is-primary"
                    style="padding: 10px;"
                    v-text="'Submit reservation request'"
                />

                <span class="ajaxMessage" v-if="ajaxMessage">
                    {{ ajaxMessage }}
                </span>
            </template>
            <div v-else class="complete-message">
                <p>Your reservation request has been submitted.</p>
            </div>
        </div>
    </div>
</template>

<script>
// import ReservationRequestTotals from '../../../_components/ReservationRequest-Totals.vue';
import {formatDateRange} from '../../../../_modules/formatDateRange';

export default {
    components: {
        // ReservationRequestTotals,
    },

    props: {
        details: {
            type: Object,
        },
        isDeposit: {
            type: Boolean,
        },
        maySubmit: {
            type: Boolean,
        },
        ajaxMessage: {
            type: String,
        },
        complete: {
            type: Boolean,
        },
    },

    computed: {
        formattedDateRange() {
            return formatDateRange(this.details.dateIn, this.details.dateOut);
        },
    },
}
</script>

<style lang="scss">
.confirm {
    .complete-message {
        p {
            margin-left: 1em;
            font-size: 120%;
            font-weight: bold;
            color: #8a5b0a;
        }
    }
}
</style>
